import { Link } from 'react-router-dom';
import { Container, Ransom } from '@/components';

export const NotFoundPage = () => {
  return (
    <Container max={760}>
      <div className="flex flex-col items-center text-center">
        <div className="ww-eyebrow" style={{ color: 'var(--ww-orange)' }}>
          Seite nicht gefunden
        </div>
        <div
          className="mt-3 font-disp leading-none text-ww-charcoal"
          style={{ fontSize: 'clamp(120px, 26vw, 240px)' }}>
          404
        </div>
        <div className="mt-2">
          <Ransom text="VERLAUFEN IM WALD" size={34} seed={13} />
        </div>
        <p className="mt-6 max-w-[420px] font-sans text-lg leading-relaxed text-ink-soft">
          Diese Seite gibt es nicht (mehr). Vielleicht ist sie im Unterholz verschwunden.
        </p>
        <Link to="/" className="ww-btn ww-btn--primary ww-btn--lg mt-8">
          Zurück zum Start →
        </Link>
      </div>
    </Container>
  );
};
